import { IRoute } from 'types/index'

const routes: IRoute[] = [
  {
    name: 'Login com senha',
    path: '/login',
    component: 'LoginPassword',
    secure: false
  },
  {
    name: 'Login com token',
    path: '/',
    component: 'Home',
    secure: false
  },
  {
    name: 'Recuperar senha',
    path: '/forgot-password',
    component: 'ForgotPassword',
    secure: false
  },
  {
    name: 'Login SMS',
    path: '/exam',
    component: 'LoginSMS',
    secure: false
  },
  {
    name: 'Login SMS',
    path: '/rdr',
    component: 'Redirect',
    secure: false
  }
]

export default routes;
